export default class PlatformDetection {
  private ua: string

  constructor(ua: string) {
    this.ua = ua
  }

  isWxwork() {
    return /wxwork/i.test(this.ua)
  }

  /**
   * Checks if the current user agent is a Weixin (WeChat) browser.
   *
   * NOTE: This method dose not include Work Weixin (WeCom).
   *
   * @returns {boolean} True if the user agent is a Weixin browser, otherwise false.
   */
  isWeixinBrowser() {
    return /micromessenger/i.test(this.ua) && !/(Windows|Mac)Wechat/i.test(this.ua) && !/wxwork/i.test(this.ua)
  }

  isMiniProgram() {
    return /miniprogram/i.test(this.ua)
  }
}
